import { NavLink, useLocation } from "react-router-dom";

const items = [
  { to: "/", label: "Home", icon: "home" },
  { to: "/browse", label: "Browse", icon: "search" },
  { to: "/create", label: "Creative", icon: "add" },
  { to: "/planner", label: "Planner", icon: "calendar_view_day" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  if (pathname === "/create") return null; // avoid covering the chat composer

  return (
    <>
      <div className="h-24 md:hidden" aria-hidden />
      <div data-testid="mobile-bottom-nav" className="md:hidden fixed bottom-5 left-1/2 -translate-x-1/2 z-40">
        <nav className="flex items-center gap-1.5 bg-black/70 backdrop-blur-xl border border-white/10 rounded-full px-2.5 py-2 shadow-2xl">
          {items.map(({ to, label, icon }) => {
            const active = to === "/" ? pathname === "/" : pathname.startsWith(to);
            return (
              <NavLink
                key={to}
                to={to}
                data-testid={`bottomnav-${label.toLowerCase()}`}
                aria-label={label}
                title={label}
                className={`w-12 h-12 rounded-full flex items-center justify-center transition-colors ${active ? "bg-nerd-light" : "hover:bg-white/10"}`}
              >
                <span
                  className="material-symbols-outlined"
                  style={{ fontSize: 24, color: active ? "#0a0a0a" : "rgba(245,245,245,0.7)" }}
                  aria-hidden="true"
                >
                  {icon}
                </span>
              </NavLink>
            );
          })}
        </nav>
      </div>
    </>
  );
}
